module.exports = __webpack_public_path__ + "img/home.68fa9acb.jpg";